module.exports = __webpack_public_path__ + "static/media/profile.442c50ed.svg";